import { render, staticRenderFns } from "./Download.html?vue&type=template&id=f3892612&scoped=true&"
import script from "./Download.js?vue&type=script&lang=js&"
export * from "./Download.js?vue&type=script&lang=js&"
import style0 from "./Download.scss?vue&type=style&index=0&id=f3892612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3892612",
  null
  
)

export default component.exports